<template>
  <div :class="resetToFirstImageClass">
    <modal
      v-if="isModalVisible"
      @close="closeModal"
      :slideIndex="currentSlideIndex"
    />
    <swiper
      class="swiper productMobileCarousel__wrapper"
      :options="swiperOption"
      ref="mobileSwiper"
    >
      <swiper-slide
        v-for="(n, index) in getEnhancedZoomerImages.MediumSize"
        :key="index"
      >
        <div class="productMobileCarousel__product_image">
          <img
            :src="
              n.Url
                ? n.Url
                : 'data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAAUCAQAAAAngNWGAAAAFElEQVR42mNkIBIwjiocVTiqEAQAJNYAFd868w4AAAAASUVORK5CYII='
            "
            :alt="n.Title"
            :class="{ wideThumbnail: n.VideoType }"
          />
          <span v-if="n.VideoType" class="playIcon"></span>
          <div class="thumbnailOverlay"></div>
          <div class="swiper-button-prev" slot="button-prev"></div>
          <div class="swiper-button-next" slot="button-next"></div>
        </div>
      </swiper-slide>
    </swiper>
    <div class="productMobileCarousel__msg">Tap to Expand</div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import { swiper, swiperSlide } from "vue-awesome-swiper";
import modal from "./Modals/EnhancedProductMobileCarouselModal.vue";

export default {
  components: {
    swiper,
    swiperSlide,
    modal
  },
  mounted() {
    this.initalSlideIndex = this.swiper.swiper.activeIndex;
  },
  updated() {
    if (
      true === this.getResetToFirstImage &&
      true === this.getIsScreenSizeMobile
    ) {
      this.slideToInitalImage();
    }
  },
  computed: {
    ...mapGetters("enhancedproduct", [
      "getEnhancedZoomerImages",
      "getResetToFirstImage",
      "getIsScreenSizeMobile"
    ]),
    swiper() {
      return this.$refs.mobileSwiper;
    },
    resetToFirstImageClass() {
      const resetImg = this.getResetToFirstImage ? "reset-img" : "";
      const mobileView = this.getIsScreenSizeMobile ? "moble-view" : "";
      return `${resetImg} ${mobileView}`;
    }
  },
  data() {
    return {
      initalSlideIndex: null,
      isModalVisible: false,
      currentSlideIndex: 0,
      swiperOption: {
        slidesPerView: 2,
        centeredSlides: true,
        loop: true,
        zoom: false,
        navigation: {
          nextEl: ".swiper-button-next",
          prevEl: ".swiper-button-prev"
        },
        on: {
          click: () => {
            // Only the active swiper image will be able to click to open the dialog
            if (
              this.swiper.swiper.clickedIndex &&
              this.swiper.swiper.clickedIndex == this.swiper.swiper.activeIndex
            ) {
              this.currentSlideIndex = this.swiper.swiper.realIndex;
              this.isModalVisible = true;
            }
          }
        }
      }
    };
  },
  methods: {
    closeModal() {
      this.isModalVisible = false;
    },
    slideToInitalImage() {
      this.swiper.swiper.slideTo(this.initalSlideIndex, 1000, false);
      this.$store.dispatch("enhancedproduct/resetToFirstImage", false);
    }
  }
};
</script>

<style lang="scss" scoped>
.swiper-slide {
  height: auto !important;
  &.swiper-slide-active {
    z-index: 10;

    .playIcon {
      width: 40% !important;
      height: 40% !important;
    }

    .thumbnailOverlay {
      display: none;
    }

    .swiper-button-prev {
      display: block;
      left: -15px;
      width: 10px !important;
      transform: translate(-50%, -50%);
      margin: 0;
      height: 20px;
    }
    .swiper-button-next {
      display: block;
      right: -25px;
      width: 10px !important;
      transform: translate(-50%, -50%);
      margin: 0;
      height: 20px;
    }
  }
}

.swiper-wrapper {
  margin-bottom: 10px;
}

.productMobileCarousel {
  &__wrapper {
    width: 100vw;
    position: relative;
    left: 50%;
    right: 50%;
    margin-left: -50vw;
    margin-right: -50vw;
    margin-bottom: 16px;
  }
  &__msg {
    bottom: 5px !important;
    color: rgb(102, 103, 102) !important;
    font-size: 12px;
    letter-spacing: 0.75px !important;
    margin-bottom: 15px;
    margin-top: -10px;
  }
  &__product_image {
    position: relative;
    min-width: 126px;
    margin: 0 15px;
    height: 100%;
    border: 1px solid #cccccc;
    img {
      // border: 1px solid rgb(204, 204, 204);
      width: 100%;
      background: #dddbdd
        url("https://res.cloudinary.com/avd/image/upload/v1588193793/ProductPage/placeholder-shimmer.gif")
        repeat-y center;

      &.wideThumbnail {
        transform: translate(-50%, -50%);
        position: absolute;
        left: 50%;
        top: 50%;
      }
    }
  }
}

.swiper-button-prev,
.swiper-button-next {
  display: none;
}

.swiper-button-prev:after,
.swiper-button-next:after {
  color: rgb(102, 102, 102);
  font-size: 14px;
}

.playIcon {
  color: $aqua;
  transform: translate(-50%, -50%);
  font-size: 70px;
  position: absolute;
  left: 50%;
  top: 50%;
  background-image: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='130' height='130' viewBox='0 0 130 130'%3E%3Cg fill='none' fill-rule='evenodd'%3E%3Cpath fill='%23000' fill-opacity='.5' d='M65,0 C29.12,0 0,29.12 0,65 C0,100.88 29.12,130 65,130 C100.88,130 130,100.88 130,65 C130,29.12 100.88,0 65,0 Z'/%3E%3Cpolygon fill='%23FFF' points='52 94.25 91 65 52 35.75'/%3E%3C/g%3E%3C/svg%3E%0A");
  width: 25%;
  height: 25%;
  background-repeat: no-repeat;
  background-size: contain;
  cursor: pointer;
}

.thumbnailOverlay {
  position: absolute;
  width: 100%;
  height: 100%;
  background: rgba(255, 255, 255, 0.7);
  top: 0;
}
</style>
